export const MANIFEST_TYPE = {
  IFCA_Manifest: '1',
  NCC: '3',
  VIPR: '4',
  DCRM: '5',
  PROJECT_MANIFEST: '6',
  ODF: '7',
  TYPE_2: '8',
};
